export const ANALYTICS_SEGMENT = 'segment';